// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zorua: PokeData = {
  "id": 570,
  "name": "zorua",
  "height": 7,
  "weight": 125,
  "base_experience": 66,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "scratch",
    "leer",
    "agility",
    "fury-swipes",
    "scary-face",
    "feint-attack",
    "pursuit",
    "torment",
    "taunt",
    "knock-off",
    "imprison",
    "fake-tears",
    "embargo",
    "punishment",
    "nasty-plot",
    "hone-claws",
    "foul-play",
    "night-daze"
  ],
  "moves": [
    "scratch",
    "leer",
    "agility",
    "scary-face",
    "pursuit",
    "night-daze",
    "quash",
    "snarl",
    "crunch",
    "bite",
    "night-slash",
    "phantom-force",
    "flatter"
  ],
  "evolution_chain": {
    "id": 291,
    "item": null,
    "species": [
      {
        "name": "zorua",
        "order": 571,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "zoroark",
        "order": 572,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": 570,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 65,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
